<template>
<div class="content">
  <div class="input-id" v-if="input_id">
    <div class="input">
      <label for="id">输入订单ID<input type="text" id="id" v-model="order_id"></label>
      <button @click="inputId">确定</button>
    </div>
  </div>
  <div class="scan-QRcode" @click="scanQRCode">
    <img class="scan-QRcode-img" src="./assets/Group@3x.png">
    <span class="scan-QRcode-hint">点击扫码</span>
  </div>
  <div class="list">
    <div class="item" v-for="(item, index) in codeList" :key="index">
      <img class="del" src="./assets/q_answer_sheet_wrong.png" alt="" @click="del(index)">
      <span class="con">{{item.dev_sn}}</span>
    </div>
    <!-- <div class="item" v-if="codeList">
      <img class="del" src="../../assets/images/q_answer_sheet_wrong.png" alt="" @click="del">
      <span class="con">{{codeList}}</span>
    </div> -->
  </div>
  <div class="submit" @click="submit">提交出库</div>
  <div v-if="showDialog" class="dialog-item">
    <dialog-item :value="massage"></dialog-item>
  </div>
</div>
</template>
<script>
import dialogItem from '@/components/dialog'
import _wx from '../../../static/js/chelun-wx-1.1.js'
import { devOutBound } from '@/http/api'

export default {
  data () {
    return {
      input_id: true,
      order_id: '',
      codeList: [],
      showDialog: false
    }
  },
  mounted () {
    // this.sendCode()
    console.log(_wx.isWx)
  },
  methods: {
    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },
    inputId () {
      localStorage.setItem('order_id', this.order_id)
      this.input_id = false
    },
    scanQRCode () {
      console.log(_wx)
      _wx.scanQRCode(1, res => {
        console.log(res)
        this.codeList.push({dev_sn: res && res.split(',')[1] ? res.split(',')[1].split('+')[1] ? res.split(',')[1].split('+')[1] : res.split(',')[1] : res})
      })
    },
    del (index) {
      this.codeList.splice(index, 1)
    },
    submit () {
      console.log({
        order_id: this.order_id ? this.order_id : localStorage.order_id,
        devices: JSON.stringify(this.codeList)
      })
      devOutBound({
        order_id: this.order_id ? this.order_id : localStorage.order_id,
        devices: JSON.stringify(this.codeList)
      }).then(res => {
        console.log(res)
        this.showDia(res.msg)
        if (res.code === 0) {
          this.codeList = []
        }
      })
    }
  },
  components: {
    'dialog-item': dialogItem
  }
}
</script>
<style lang="scss" scoped>
.input-id {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #fff;
  z-index: 999;
  .input {
    font-size: .32rem;
    padding: 0 .3rem;
    box-sizing: border-box;
    // display: flex;
    // display: -webkit-flex;
    // align-items: center;
    height: 100%;
    text-align: center;
    label {
      margin-top: .6rem;
      display: inline-block;
    }
    input {
      margin-left: .4rem;
      border: 1px solid #dedede;
      height: .68rem;
      line-height: .68rem;
      border-radius: .08rem;
      width: 3rem;
      padding: 0 .2rem;
      font-size: .3rem;
    }
    button {
      display: block;
      margin: .2rem auto;
      color: #fff;
      background: #02B389;
      border-radius: .1rem;
      text-align: center;
      font-size: .32rem;
      margin: .8rem auto;
      width: 2rem;
      height: .88rem;
      line-height: .88rem;
    }
  }
}
.scan-QRcode {
  background: #fff;
  padding-top: .50rem;
  position: relative;
}

.scan-QRcode-img {
  width: 1.96rem;
  display: block;
  margin: auto;
}
.scan-QRcode-hint {
  margin-top: .16rem;
  display: block;
  text-align: center;
  color: rgba(64, 64, 64, 0.6);
  font-size: .28rem;
}
.list {
  padding: 0 .3rem;
  margin-top: .4rem;
}
.item {
  position: relative;
  width: 3.6rem;
  text-align: center;
  display: block;
  font-size: .44rem;
  line-height: .9rem;
  padding: 0 .2rem;
  background: #eee;
  /* margin-right: .5rem; */
  margin: auto;
  border-radius: .06rem;
  .del {
    position: absolute;
    width: .26rem;
    height: .26rem;
    top: -.1rem;
    right: -.1rem;
  }
}
.submit {
  color: #fff;
  background: #02B389;
  border-radius: .1rem;
  text-align: center;
  font-size: .32rem;
  margin: .8rem auto;
  width: 2rem;
  height: .88rem;
  line-height: .88rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/fun/sendGoods.vue